import api from '@/api'

const state = {
  unreadNotifications: 0
}

const getters = {
  unreadNotifications: (state) => {
    return state.unreadNotifications
  }
}

const mutations = {
  setUnreadCount (state, payload) {
    state.unreadNotifications = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
